<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "serve-editor"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/serve-editor.vue